export default __webpack_public_path__ + "static/media/Linde Material Handling.5667104b.png";